module.exports = __webpack_public_path__ + "static/rosette-2b5294749bec0d6bee0f591679ded78c.png";